<template>
  <div class="picker-input" :class="{ 'picker-input--has-info': info }">
    <div
      v-if="info"
      class="picker-input__info-wrap"
      @mouseenter="onInfoEnter"
      @mouseleave="onInfoLeave"
    >
      <v-icon
        small
        :color="showInfo ? '#2563eb' : '#6b7280'"
        class="picker-input__info-icon"
        @click.stop="toggleInfo"
      >
        mdi-information-outline
      </v-icon>

      <transition name="picker-input-info-fade">
        <div v-if="showInfo" class="picker-input__info-bubble" @click.stop>
          {{ info }}
        </div>
      </transition>
    </div>

    <div class="picker-input__field-wrap">
      <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-img
            :style="{
              width: '20px',
              height: '25px',
              position: 'absolute',
              left: '12px',
              top: '20px',
            }"
            id="logo"
            contain
            src="@/assets/calendarGray.svg"
          />
          <i
            aria-hidden="true"
            @click="handleDelete"
            :style="{
              position: 'absolute',
              left: '33px',
              top: '21px',
            }"
            class="v-icon notranslate mdi mdi-close theme--light"
          ></i>
          <v-text-field
            v-model="date"
            :label="label"
            prepend-icon="mdi-calendar"
            outlined
            dense
            v-bind="attrs"
            v-on="on"
            readonly
            class="remove-padding-v-slot"
          ></v-text-field>
        </template>

        <v-date-picker
          v-model="date"
          :active-picker.sync="activePicker"
          :max="new Date(new Date().getFullYear() + 3, 11, 31).toISOString().substr(0, 10)"
          min="1950-01-01"
          @change="save"
        ></v-date-picker>
      </v-menu>
    </div>
  </div>
</template>

<script>
export default {
  name: "pickerInput",
  props: ["name", "label", "info"],

  data: () => ({
    activePicker: null,
    date: null,
    menu: false,
    infoOpen: false,
    infoHover: false,
    infoDismissed: false,
  }),

  computed: {
    showInfo() {
      return this.infoOpen || this.infoHover;
    },
  },

  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = 'YEAR'))
    },
  },

  methods: {
    toggleInfo() {
      if (this.infoOpen) {
        this.infoOpen = false;
        this.infoDismissed = true;
        this.infoHover = false;
        return;
      }
      this.infoOpen = true;
      this.infoDismissed = false;
    },
    onInfoEnter() {
      if (!this.infoDismissed) {
        this.infoHover = true;
      }
    },
    onInfoLeave() {
      this.infoHover = false;
      this.infoDismissed = false;
    },
    handleDelete() {
      this.date = null
      this.$emit('dateValue', this.date)
    },
    save(date) {
      this.$refs.menu.save(date)
      this.$emit('dateValue', date)
    },
  },
}
</script>

<style>
.picker-input {
  position: relative;
}

.picker-input--has-info {
  padding-top: 26px;
}

.picker-input--has-info .picker-input__info-wrap {
  top: 0;
}

.picker-input__field-wrap {
  position: relative;
}

.picker-input__info-wrap {
  position: absolute;
  top: 2px;
  right: 8px;
  z-index: 4;
}

.picker-input__info-icon {
  cursor: pointer;
}

.picker-input__info-bubble {
  position: absolute;
  right: 100%;
  margin-right: 8px;
  top: 50%;
  transform: translateY(-50%);
  width: max-content;
  max-width: none;
  padding: 6px 12px;
  background: #eff6ff;
  border: 1px solid #93c5fd;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.12);
  color: #1e3a8a;
  font-size: 13px;
  line-height: 1.4;
  text-align: right;
  white-space: nowrap;
}

.picker-input-info-fade-enter-active,
.picker-input-info-fade-leave-active {
  transition: opacity 0.15s ease, transform 0.15s ease;
}

.picker-input-info-fade-enter,
.picker-input-info-fade-leave-to {
  opacity: 0;
  transform: translateY(-50%) translateX(8px);
}

.remove-padding-v-slot input {
  padding-right: 7px;
}
</style>
